import { Injectable } from '@angular/core';
import Swal from 'sweetalert2';
import { Router } from '@angular/router';
import { ExcelService } from './excel.service';

@Injectable({
  providedIn: 'root'
})
export class GlobalAlertService {
  htmlSwal;

  constructor(
    public route: Router,
    private excelService: ExcelService
  ) { }

  ///////////////////////////////////////////////////////////////////// GENERAL ALERT /////////////////////////////////////////////////////////////////////////
  /* METHOD FOR ERROR ALERT   -----   PARAMS: TEXT:STRING */
  descErr(text?: string) {
    if (text == undefined) {
      Swal.fire({
        title: '<strong>Oops...</strong>',
        icon: 'error',
        html: ' <b>Algo anda mal</b>, ' +
          '<h3> Verifique que no haya campos vacíos e intente nuevamente <h3> ',
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonColor: '#00bba4',
        confirmButtonText: '¡Entendido!',
      });
    } else {
      Swal.fire({
        title: '<strong>Oops...</strong>',
        icon: 'error',
        html: ' <b>Algo anda mal</b>, ' +
          '<h3 style="margin-top: 16px">' + text + '<h3> ',
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonColor: '#00bba4',
        confirmButtonText: '¡Entendido!',
      });
    }
  }

  descinfo(text?: string) {
    if (text == undefined) {
      Swal.fire({
        title: '<strong>Informacion</strong>',
        icon: 'error',
        html: ' <b>Algo anda mal</b>, ' +
          '<h3> Verifique que no haya campos vacíos e intente nuevamente <h3> ',
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonColor: '#00bba4',
        confirmButtonText: '¡Entendido!',
      });
    } else {
      Swal.fire({
        title: '<strong>Informacion</strong>',
        icon: 'info',
        html: ' <b>Es necesario validar</b>, ' +
          '<h3>' + text + '<h3> ',
        showCloseButton: true,
        showCancelButton: false,
        focusConfirm: false,
        confirmButtonColor: '#00bba4',
        confirmButtonText: '¡Entendido!',
      });
    }
  }

  descAlert(text?: string, dataJSONtoXLSX?: any) {
    Swal.fire({
      title: '<strong>Información</strong>',
      icon: 'warning',
      html: text == undefined
        ? '<b>Algo anda mal. Verifique que no haya campos vacíos e intente nuevamente</b>'
        : dataJSONtoXLSX == undefined
          ? `<b>Es necesario validar</b>`
          : `<h2><b>${text}</b></h2><span>Algunas facturas no fueron procesadas completamente. Descargue el reporte para un informe detallado o continue para refacturar.</span>`,
      showCancelButton: dataJSONtoXLSX != undefined ? true : false,
      cancelButtonColor: "#00bba4",
      cancelButtonText: 'Continuar',
      confirmButtonColor: '#464CA7',
      confirmButtonText: dataJSONtoXLSX != undefined ? 'Descargar Reporte' : 'Continuar',
      focusConfirm: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await this.excelService.exportExcelFacturacion(dataJSONtoXLSX)
        Swal.fire("Reporte Descargado con éxito", "", "success");
      }
    });
  }

  /* METHOD FOR VALID ALERT   -----   PARAMS: TEXT:STRING */
  descValid(text?: string, dataJSONtoXLSX?: any) {
    Swal.fire({
      title: '<strong>¡Genial!</strong>',
      icon: 'success',
      html: text == undefined
        ? '<b>¡El registro se ha creado con éxito!</b>'
        : `<h2><b>${text}.</b></h2> ${dataJSONtoXLSX != undefined
          ? '<span>Ahora puede continuar y descargar el informe detallado del proceso realizado.</span>'
          : ''}`,
      showCancelButton: dataJSONtoXLSX != undefined ? true : false,
      cancelButtonColor: "#00bba4",
      cancelButtonText: '¡Entendido!',
      confirmButtonColor: '#464CA7',
      confirmButtonText: dataJSONtoXLSX != undefined ? 'Descargar Reporte' : 'Continuar',
      focusConfirm: false,
    }).then(async (result) => {
      if (result.isConfirmed) {
        await this.excelService.exportExcelFacturacion(dataJSONtoXLSX)
        Swal.fire("Reporte Descargado con éxito", "", "success");
      }
    });

    // if (text == undefined) {
    //   Swal.fire({
    //     title: '<strong>¡Genial!</strong>',
    //     icon: 'success',
    //     html: ' <b>¡El registro se ha creado con éxito!</b> ',
    //     showCloseButton: true,
    //     showCancelButton: false,
    //     confirmButtonColor: '#00bba4',
    //     confirmButtonText: '¡Entendido!',
    //   });
    // } else {
    //   Swal.fire({
    //     title: '<strong>¡Genial!</strong>',
    //     icon: 'success',
    //     html: ' <b>' + text + '</b> ',
    //     showCloseButton: true,
    //     showCancelButton: false,

    //     focusConfirm: false,
    //   });
    // }
  }
  ///////////////////////////////////////////////////////END GENERAL ALERT//////////////////////////////////////////////////////////////////////

  closeValid() {
    Swal.fire({
      title: '<strong>¡Visita cerrada con éxito!</strong>',
      icon: 'success',
      html: ' <b>La visita de mantenimiento se cerró con éxito</b>, ',
      showCloseButton: true,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonColor: '#00bba4',
      confirmButtonText: '¡Entendido!',
    });
  }

  excelErr(campo) {
    Swal.fire({
      title: '<strong>Oops...</strong>',
      icon: 'error',
      html: ' <b>Algo anda mal</b>, ' +
        '<h3>  El excel cargado no inlcuye el Campo ' + campo + ' <h3> ',
      showCloseButton: true,
      showCancelButton: false,
      focusConfirm: false,
      confirmButtonColor: '#00bba4',
      confirmButtonText: '¡Entendido!',
    });
  }

}
